<template>
    <div class="background-small">
        <section class="services-container">
            <h3>Our Services</h3>

            <div class="services-list">
                <div class="service-card" v-for="(feature, index) in features" :key="index">
                    <img :src="feature.img" alt="feature icon" class="service-img" />
                    <h3 class="service-title">{{ feature.title }}</h3>
                    <p class="service-description">{{ feature.description }}</p>
                    <router-link :to="feature.link" class="service-link">
                        Learn More
                    </router-link>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import caseIcon from "@/assets/images/case.png";
import transfer from "@/assets/images/transfer.png";
import inventoryIcon from "@/assets/images/briefcase.png";
import manage from "@/assets/images/checklist.png";
import trend from "@/assets/images/trend-chart.png";
import invest from "@/assets/images/investments.png";
import gift from "@/assets/images/gift.png";
import target from "@/assets/images/target.png";
import portfolio from "@/assets/images/portfolio.png";
import watchlist from "@/assets/images/add-bookmark.png";

const features = ref([
    {
        title: "Case Opening Simulator",
        description: "Try your luck with the FREE CS2 case opening simulator.",
        img: caseIcon,
        link: "/cs2/simulator",
    },
    {
        title: "Manage Your Trades",
        description: "Manage all your trades at one place.",
        img: manage,
        link: "/dashboard",
    },
    {
        title: "Inventory",
        description: "Track your CS2, Dota2, TF2 and Rust inventories.",
        img: inventoryIcon,
        link: "/inventory",
    },
    {
        title: "Price Comparison",
        description:
            "Compare item prices across 20 marketplaces to maximize profits.",
        img: transfer,
        link: "/comparison",
    },
    {
        title: "Price Trends",
        description: "Get real-time updates on skin market trends.",
        img: trend,
        link: "/trends",
    },
    {
        title: "Investment Tracker",
        description: "Track your item investments easily in one place.",
        img: invest,
        link: "/investments",
    },
    {
        title: "Portfolio",
        description:
            "Create a portfolio to easily track and analyze your total worth.",
        img: portfolio,
        link: "/analytics",
    },
    {
        title: "Watchlist",
        description:
            "Observe price movements by adding desired items to your watch list.",
        img: watchlist,
        link: "/watchlist",
    },
    {
        title: "Price Targets",
        description:
            "Get notified when the items you follow hit your target price drops.",
        img: target,
        link: "/target",
    },
    {
        title: "Free Giveaways",
        description:
            "Participate in free giveaways for a chance to win exclusive CS2 skins",
        img: gift,
        link: "/giveaways",
    },
]);
</script>

<style scoped>
.services-container {
    max-width: 1200px;
    margin: 0 auto;
    font-family: Arial, sans-serif;
}

.services-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 40px;
    font-weight: bold;
    color: white;
}

.services-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 30px;
    margin-top: 2rem;
}

.service-card {
    border-radius: 6px;
    background-color: #00000063;
    border: 1px solid transparent;
    padding: 2.5rem 1.5rem;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: transform 0.3s ease-in-out;
}

.service-card:hover {
    transform: translateY(-10px);
}

.service-img {
    max-width: 75px;
    height: auto;
    margin-bottom: 15px;
    border-radius: 8px;
}

.service-title {
    font-size: 22px;
    margin-bottom: 10px;
    font-weight: 600;
    color: white;
}

.service-description {
    font-size: 15px;
    color: white;
    margin-bottom: 20px;
    line-height: 1.6;
}

.service-link {
    display: inline-block;
    padding: 10px 20px;
    background-color: #954ce9;
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
    font-weight: 600;
    transition: background-color 0.3s ease;
}

.service-link:hover {
    background-color: #0056b3;
}

h3 {
    color: white;
}
</style>